import { select } from 'redux-saga/effects';

import AnalyticsService from '../../../services/analytics.service';
import AnalyticsEvents from '../../../services/analytics.constants';

export default function* completeEnrollment(action) {
  const { payload } = action;
  const email = yield select((state) => state.user?.email) || {};
  const groupId = yield select((state) => state.organization?.uuid) || {};
  AnalyticsService.track(AnalyticsEvents.UserEnrolled, payload, {
    groupId,
    traits: { email },
  });
}
